import { Controller } from "@hotwired/stimulus"
import { smartMatch } from "../../utils/smart_search"

export default class extends Controller {
  static targets = [
    "scopeSelector",
    "staffSelection",
    "jobFunctionsSelection",
    "schoolSelection",
    "staffSearch",
    "staffList",
    "staffCount",
    "submitButton"
  ]

  connect() {
    this.showInitialScope()
    this.updateFormState()
  }

  showInitialScope() {
    const checked = this.element.querySelector('input[name="generate_staff_card[generation_scope]"]:checked')
    if (!checked) return

    this.hideAllSelectionSections()

    switch(checked.value) {
      case 'staff':
        this.showStaffSelection()
        break
      case 'job_functions':
        this.showJobFunctionsSelection()
        break
      case 'school':
        this.showSchoolSelection()
        break
    }
  }

  updateScope(event) {
    const scope = event.target.value
    this.hideAllSelectionSections()

    switch(scope) {
      case 'staff':
        this.showStaffSelection()
        break
      case 'job_functions':
        this.showJobFunctionsSelection()
        break
      case 'school':
        this.showSchoolSelection()
        break
    }

    this.updateFormState()
  }

  hideAllSelectionSections() {
    if (this.hasStaffSelectionTarget) {
      this.staffSelectionTarget.classList.add('hidden')
    }
    if (this.hasJobFunctionsSelectionTarget) {
      this.jobFunctionsSelectionTarget.classList.add('hidden')
    }
    if (this.hasSchoolSelectionTarget) {
      this.schoolSelectionTarget.classList.add('hidden')
    }
  }

  showStaffSelection() {
    if (this.hasStaffSelectionTarget) {
      this.staffSelectionTarget.classList.remove('hidden')
    }
  }

  showJobFunctionsSelection() {
    if (this.hasJobFunctionsSelectionTarget) {
      this.jobFunctionsSelectionTarget.classList.remove('hidden')
    }
  }

  showSchoolSelection() {
    if (this.hasSchoolSelectionTarget) {
      this.schoolSelectionTarget.classList.remove('hidden')
    }
  }

  updateSelection() {
    const checkedBoxes = this.element.querySelectorAll('input[name="generate_staff_card[target_ids][]"]:checked')
    const count = checkedBoxes.length

    if (this.hasStaffCountTarget) {
      this.staffCountTarget.textContent = count
    }

    this.updateFormState()
  }

  filterStaff() {
    this.applyStaffFilter()
  }

  setPhotoFilter(event) {
    const button = event.currentTarget
    this.photoFilter = button.getAttribute('data-filter') || 'all'

    button.parentElement.querySelectorAll('.ds-segmented__btn').forEach(btn => {
      btn.setAttribute('aria-pressed', btn === button ? 'true' : 'false')
    })

    this.applyStaffFilter()
  }

  applyStaffFilter() {
    const searchTerm = this.hasStaffSearchTarget ? this.staffSearchTarget.value : ''
    const photoFilter = this.photoFilter || 'all'
    const labels = this.staffListTarget.querySelectorAll('label[data-staff-name]')

    labels.forEach(label => {
      const staffName = label.getAttribute('data-staff-name') || ''
      const staffMat = label.getAttribute('data-staff-mat') || ''
      const hasPhoto = label.getAttribute('data-has-photo') === 'true'

      const matchesSearch = smartMatch([staffName, staffMat], searchTerm)
      const matchesPhoto = photoFilter === 'all'
        || (photoFilter === 'with' && hasPhoto)
        || (photoFilter === 'without' && !hasPhoto)

      label.style.display = matchesSearch && matchesPhoto ? 'block' : 'none'
    })
  }

  updateFormState() {
    const scope = this.element.querySelector('input[name="generate_staff_card[generation_scope]"]:checked')?.value
    let isValid = false

    if (scope) {
      switch(scope) {
        case 'staff':
          const selectedStaff = this.element.querySelectorAll('input[name="generate_staff_card[target_ids][]"]:checked')
          isValid = selectedStaff.length > 0
          break
        case 'job_functions':
          const selectedFunctions = this.element.querySelectorAll('input[name="generate_staff_card[target_ids][]"]:checked')
          isValid = selectedFunctions.length > 0
          break
        case 'school':
          isValid = true
          break
      }
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !isValid

      if (isValid) {
        this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      } else {
        this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
      }
    }
  }
}
